import { render, staticRenderFns } from "./CompanyHero.vue?vue&type=template&id=3f473d9a&scoped=true"
import script from "./CompanyHero.vue?vue&type=script&lang=js"
export * from "./CompanyHero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f473d9a",
  null
  
)

export default component.exports